class UIButtonTags {
    static selectors = {
        'wrapper'   : '.js-button-tags',
        'list'      : '.js-tag-list',
        'button'    : '.js-button-tag',
        'toggle'    : '.js-list-toggle',
        'set_active': '.js-button-tag.js-set-active'
    };

    static classes = {
        active  : 'is-tag-active',
        hidden  : 'is-tag-hidden',
        expanded: 'is-expanded'
    };
    
    static event_names = {
        active: 'button-tag-active'
    };

    constructor() {
        const that = this;

        that.init();
    }

    init() {
        const that = UIButtonTags;

        // Toggle
        const toggle_selector = [that.selectors.wrapper, that.selectors.toggle].join(' ');
        $.sa.$document.on('click', toggle_selector, function() {
            const $button_tags = $(this).closest(that.selectors.wrapper);
            that.toggle($button_tags);
        });

        // Set Active
        const active_selector = [that.selectors.wrapper, that.selectors.set_active].join(' ');
        $.sa.$document.on('click', active_selector, function() {
            const $button = $(this);
            that.setActive($button);
        });
    }

    /**
     * @param {jQuery} $button_tags
     * @param {Boolean?} toggle
     * */
    static toggle($button_tags, toggle = null) {
        const that = UIButtonTags;

        if (typeof toggle === "boolean") {
            if (toggle) {
                $button_tags.addClass(that.classes.expanded);
            } else {
                $button_tags.removeClass(that.classes.expanded);
            }
        } else {
            $button_tags.toggleClass(that.classes.expanded);
        }
    }

    /**
     * @param {jQuery} $button
     * @param {Boolean?} active
     * */
    static setActive($button, active = true) {
        const that = UIButtonTags;

        if (active) {
            $button.addClass(that.classes.active);    
        } else {
            $button.removeClass(that.classes.active);
        }

        $button.trigger(that.event_names.active);
    }

    /**
     * @param {jQuery} $button
     * @return {Boolean}
     * */
    static isActive($button) {
        const that = UIButtonTags;
        return $button.hasClass(that.classes.active);
    }

    /**
     * @param {jQuery} $wrapper
     * */
    static clear($wrapper) {
        const that = UIButtonTags;

        $wrapper.find(that.selectors.button + '.' + that.classes.active).each( function() {
            that.setActive($(this), false);
        });
    }
}